import { DashboardMetricCard, SkeletonText } from '@/components';
import { Bell } from '../../components/Icons';
import { useFormatters } from '../../hooks/useFormatters';
import { SUMMARY_CARDS } from '../utils';

export function RemindersSummaryCards({
  summary,
  isLoading,
  onCardClick,
  className = '',
}) {
  const { formatNumber } = useFormatters();

  if (isLoading) {
    return (
      <div
        className={`grid grid-cols-2 gap-2 font-sf-pro-display sm:gap-3 md:grid-cols-3 xl:grid-cols-6 mb-3 shrink-0 ${className}`}
      >
        {SUMMARY_CARDS.map((card) => (
          <div
            key={card.key}
            className="relative flex min-h-[64px] w-full flex-row items-center gap-2 overflow-hidden rounded-[12px] bg-white py-2.5 pl-3.5 pr-2.5 text-left shadow-[0_1px_3px_rgba(0,0,0,0.06)] sm:min-h-[88px] sm:gap-3 sm:px-4 sm:py-3"
          >
            <span
              className="absolute bottom-2.5 left-0 top-2.5 w-[4px] rounded-r-full sm:bottom-3 sm:top-3"
              style={{ backgroundColor: card.accent }}
            />
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px] bg-gray-100 animate-pulse sm:h-12 sm:w-12" />
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <SkeletonText width="w-16 sm:w-20" height="h-3.5 sm:h-4" />
              <SkeletonText width="w-10 sm:w-12" height="h-5 sm:h-6" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      className={`grid grid-cols-2 gap-2 font-sf-pro-display sm:gap-3 md:grid-cols-3 xl:grid-cols-6 mb-3 shrink-0 ${className}`}
    >
      {SUMMARY_CARDS.map((card) => (
        <DashboardMetricCard
          key={card.key}
          title={card.title}
          value={formatNumber(summary?.[card.key] ?? 0)}
          icon={Bell}
          iconBg={card.iconBg}
          accent={card.accent}
          onClick={onCardClick ? () => onCardClick(card.filter) : undefined}
        />
      ))}
    </div>
  );
}
